import { render, staticRenderFns } from "./causelectric.vue?vue&type=template&id=04c8c42c&"
import script from "./causelectric.vue?vue&type=script&lang=js&"
export * from "./causelectric.vue?vue&type=script&lang=js&"
import style0 from "./causelectric.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports